module.exports = __webpack_public_path__ + "img/emvco.fa724803.svg";